<!-- <p>Mind - elixir showing</p> -->
<!-- <div id="mindMapContainer"></div> -->
<div class="disable-css" id="map"></div>